import React from 'react';
import EditarDatosPersonales from '../components/gestorDatos/DetalleDatosPersonales';

export const DatosPersonales = () => (
  <div>
    <EditarDatosPersonales />
  </div>
);
